// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3GkxC","rootSuccess":"CompleteLink_rootSuccess__24kUW","rootFailure":"CompleteLink_rootFailure__laMjU","isDisabled":"CompleteLink_isDisabled__1LGBw"};